import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { MonitoringSeriesTypeEnum } from '../enums/monitoring-series-type.enum';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';
import { MentionSearchCriteriaModel } from './mention-search-criteria.model';
import { monitoringFiltersEnum } from '../enums/monitoring-filters.enum';

export interface MonitoringSourcePickerFieldOptions {
    dataSourceLabel?: string;
    dateRangeLabel?: string;
    mentionCountLocalizationLabel?: string;
    mentionCountLimitExceededLocalizationTitle?: string;
    mentionCountLimitExceededLocalizationLabel?: string;
    maxNumberOfMentions?: number;
    warningNumberOfMentions?: number;
    dataSourceNullErrorMessage?: string;
    dataSourceOptions?: DropdownOptionModel[];
    showDataSourceError?: boolean;
    horizontalOrientation?: boolean;
    showResultsFeedback?: boolean;
    showLoadingFeedback?: boolean;
    showFilters?: boolean;
    showDateRange?: boolean;
    showViewSource?: boolean;
    showTooManyMentionsError?: boolean;
    showResultsFeedbackAnalysis?: boolean;
    filterCriteria?: MentionSearchCriteriaModel;
    orderedAccountFilters?: monitoringFiltersEnum[];
    orderedMercuryFilters?: monitoringFiltersEnum[];
    separatedErrors?: boolean;
}

export class MonitoringSourcePickerFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    dataSourceLabel: string;
    dateRangeLabel: string;
    mentionCountLocalizationLabel: string;
    mentionCountLimitExceededLocalizationTitle: string;
    mentionCountLimitExceededLocalizationLabel: string;
    maxNumberOfMentions: number;
    warningNumberOfMentions: number;
    dataSourceNullErrorMessage: string;
    dataSourceOptions: DropdownOptionModel[];
    showDataSourceError: boolean;
    horizontalOrientation: boolean;
    showResultsFeedback: boolean;
    showLoadingFeedback: boolean;
    showFilters: boolean;
    showDateRange: boolean;
    showViewSource: boolean;
    showTooManyMentionsError: boolean;
    showResultsFeedbackAnalysis: boolean;
    filterCriteria: MentionSearchCriteriaModel;
    orderedAccountFilters: monitoringFiltersEnum[];
    orderedMercuryFilters: monitoringFiltersEnum[];
    separatedErrors: boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        {
            dataSourceLabel,
            dateRangeLabel,
            mentionCountLocalizationLabel,
            mentionCountLimitExceededLocalizationTitle,
            mentionCountLimitExceededLocalizationLabel,
            maxNumberOfMentions,
            warningNumberOfMentions,
            dataSourceNullErrorMessage,
            dataSourceOptions = [
                new DropdownOptionModel('Reports.series.type.folder', MonitoringSeriesTypeEnum.folder),
                new DropdownOptionModel('Reports.series.type.topic', MonitoringSeriesTypeEnum.topic)
            ],
            showDataSourceError = false,
            horizontalOrientation = false,
            showResultsFeedback = true,
            showLoadingFeedback = true,
            showFilters = false,
            showDateRange = true,
            showViewSource = false,
            showTooManyMentionsError = true,
            showResultsFeedbackAnalysis = false,
            filterCriteria,
            orderedAccountFilters,
            orderedMercuryFilters,
            separatedErrors = false
        }: MonitoringSourcePickerFieldOptions
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;

        // options
        this.dataSourceLabel = dataSourceLabel;
        this.dateRangeLabel = dateRangeLabel;
        this.mentionCountLocalizationLabel = mentionCountLocalizationLabel;
        this.mentionCountLimitExceededLocalizationTitle = mentionCountLimitExceededLocalizationTitle;
        this.mentionCountLimitExceededLocalizationLabel = mentionCountLimitExceededLocalizationLabel;
        this.maxNumberOfMentions = maxNumberOfMentions;
        this.warningNumberOfMentions = warningNumberOfMentions;
        this.dataSourceNullErrorMessage = dataSourceNullErrorMessage;
        this.showDataSourceError = showDataSourceError;
        this.horizontalOrientation = horizontalOrientation;
        this.showResultsFeedback = showResultsFeedback;
        this.showLoadingFeedback = showLoadingFeedback;
        this.showFilters = showFilters;
        this.showDateRange = showDateRange;
        this.showViewSource = showViewSource;
        this.showTooManyMentionsError = showTooManyMentionsError;
        this.showResultsFeedbackAnalysis = showResultsFeedbackAnalysis;
        this.filterCriteria = filterCriteria;
        this.dataSourceOptions = dataSourceOptions;
        this.orderedAccountFilters = orderedAccountFilters;
        this.orderedMercuryFilters = orderedMercuryFilters;
        this.separatedErrors = separatedErrors;
    }
}
